<template>
  <el-dialog
    :visible.sync="isShow"
    width="480px"
    custom-class="ShortDialog"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="dialog-body">
      <div class="d-header">
        <div class="left">
          <span>{{ title }}</span>
        </div>
        <fm-button
          @click="handleClose"
          type="info"
          size="mini"
          text
          icon="icon-model-close"
        ></fm-button>
      </div>
      <div class="d-content" v-loading="loading2">
        <!-- 公共说明 -->
        <div class="warn-box">
          <svg-btn icon-class="icon-tips-circle-fill" />
          <span>严禁分享反动、暴力、色情、违法及侵权内容的链接。</span>
        </div>
        <!-- 单个新建 -->
        <div class="shortLink" v-if="isType == 1">
          <!-- 短链信息 创建成功 -->
          <div class="file-info" v-if="isStatus == 2">
            <div class="file_icon">
              <img class="icon" :src="web_icon" @error="onError($event)" />
            </div>
            <div class="info">
              <div class="nameBox">
                <span class="name">{{ url_title }}</span>
                <svg-btn
                  @click="editLink"
                  class="edit"
                  icon-class="icon-short-edit"
                />
              </div>
              <span class="link">{{ jump_url }}</span>
            </div>
          </div>

          <!-- 目标网址和标题 循环list -->
          <div
            class="arrBox"
            ref="arrRef"
            v-show="isStatus == 1 || isStatus == 3"
          >
            <transition-group 
              name="link-item" 
              tag="div" 
              :css="editType !== 1">
              <div
                v-for="(item, index) in arrList"
                :key="item.key || index"
                :ref="'card' + index"
                :class="{
                  arr: true,
                  arrError: item.empty || item.domin,
                }"
              >
                <!-- 目标网址 新建 编辑 -->
                <div class="box">
                  <div class="fontBox" style="justify-content: space-between">
                    <div class="left">
                      <span class="red">*</span>
                      <span class="font">目标网址{{ index + 1 }}</span>
                    </div>
                    <div
                      class="right"
                      v-if="arrList.length > 1"
                      @click="removeArr(index)"
                    >
                      <svg-btn
                        class="icon3"
                        icon-class="icon-shortLink-delete"
                      />
                      <span class="font2">删除</span>
                    </div>
                  </div>
                  <div class="inputBox">
                    <img
                      class="img"
                      @error="onError($event)"
                      :src="getIconSrc(item)"
                    />
                    <el-input
                      v-model="item.jump_url"
                      clearable
                      class="linkInput"
                      placeholder="请输入需要缩短的链接"
                      @focus="handleInputFocus(item)"
                      @blur="handleInputBlur(item)"
                      @input="handleInput(item,1)"
                    ></el-input>
                  </div>
                </div>
                <div
                  class="box"
                  style="margin-bottom: 0"
                >
                  <div class="fontBox">
                    <div class="left">
                      <span class="red">*</span>
                      <span class="font">标题{{ index + 1 }}</span>
                    </div>
                  </div>
                  <el-input
                    class="title"
                    v-model="item.url_title"
                    resize="none"
                    autosize
                    placeholder="请输入短链标题（最多50字）"
                    maxlength="50"
                    type="textarea"
                    @input="handleInput(item,2)"
                  >
                  </el-input>
                </div>
              </div>
            </transition-group>
          </div>
          <div
            class="btnBox"
            v-if="(isStatus == 1 || isStatus == 3) && arrList.length < maxCount"
          >
            <div class="addBtn" @click="addArr()">
              <svg-btn class="icon" icon-class="icon-shortLink-add"></svg-btn>
              <span class="addFont">添加目标网址</span>
            </div>
          </div>

          <!-- 分享模式 -->
          <div class="formBox" style="margin-top: 24px">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">分享模式</span>
                <el-tooltip
                  effect="dark"
                  content="开通CloudMaster立即体验所有分享模式"
                  placement="top"
                >
                  <svg-btn class="icon" icon-class="icon-share-1" />
                </el-tooltip>
              </div>
              <span class="right" @click="toCm">查看分享简介</span>
            </div>
            <!-- :class="{
                disSelet: isStatus == 2,
              }"
              :disabled="isStatus == 2" -->
            <el-select
              v-model="rebate_model"
              popper-class="share_select"
              placeholder="请选择短链分享模式"
              @change="incomeModeChange"
            >
              <el-option
                v-for="item in rebateList"
                :key="item.name"
                :label="item.name"
                :style="item.disabled == '1' ? 'cursor: pointer ' : ''"
                :value="item.name"
                :disabled="item.disabled == 1"
              >
                <div class="share_select_box" @click.prevent="toDaren(item)">
                  <div
                    class="income-name"
                    :class="item.disabled == '0' ? '' : 'income-name1'"
                  >
                    {{ item.name }}
                  </div>
                  <div class="income-right">
                    <div
                      class="income-intr"
                      v-if="item.info"
                      :class="
                        item.disabled == '1'
                          ? 'income-daren0'
                          : item.disabled == '0'
                          ? 'income-daren'
                          : ''
                      "
                    >
                      <img
                        v-if="item.disabled == '1'"
                        style="width: 14px; height: 14px; margin-right: 2px"
                        :src="$utils.getPng('web4/icon_mom')"
                      />
                      {{ item.info }}
                    </div>
                    <div class="income-checkbox">
                      <img
                        class="icon-scheck"
                        v-show="item.name == rebate_model"
                        :src="$utils.getPng('web4/icon-share-check')"
                      />
                    </div>
                  </div>
                </div>
              </el-option>
            </el-select>
          </div>

          <!-- 分享短链 创建成功 -->
          <div class="formBox" style="margin-bottom: 0" v-if="isStatus == 2">
            <div class="fontBox">
              <span class="font">分享短链</span>
            </div>
            <div class="urlBox">
              <el-input
                readonly
                v-model="share_url"
                placeholder=""
                clearable
              ></el-input>
              <fm-button
                class="copy-btn"
                round
                size="medium"
                @click="copyUrl(1)"
                >复制短链</fm-button
              >
            </div>
          </div>
        </div>
        <!-- 批量新建 -->
        <div class="shortLink" v-if="isType == 2" style="padding-top: 16px">
          <!-- 目标网址 新建 编辑 -->
          <div class="formBox" v-if="isStatus == 1">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">目标网址</span>
              </div>
            </div>
            <el-input
              class="allTitle"
              v-model="jump_url"
              resize="none"
              autosize
              placeholder="请输入需要缩短的链接（最多一次添加20个，每行一个）"
              type="textarea"
            >
            </el-input>
          </div>

          <!-- 标题 新建 编辑 -->
          <div class="formBox" v-if="isStatus == 1">
            <div class="fontBox">
              <span class="red">*</span>
              <span class="font">标题</span>
            </div>
            <el-input
              class="titleAll"
              v-model="url_title"
              resize="none"
              autosize
              placeholder="请输入短链标题（每行一个）"
              type="textarea"
            >
            </el-input>
          </div>

          <!-- 分享模式 -->
          <div class="formBox" v-if="isStatus == 1" style="margin-bottom: 0">
            <div class="fontBox" style="justify-content: space-between">
              <div class="left">
                <span class="red">*</span>
                <span class="font">分享模式</span>
                <el-tooltip
                  effect="dark"
                  content="开通CloudMaster立即体验所有分享模式"
                  placement="top"
                >
                  <svg-btn class="icon" icon-class="icon-share-1" />
                </el-tooltip>
              </div>
              <span class="right" @click="toCm">查看分享简介</span>
            </div>
            <el-select
              v-model="rebate_model"
              popper-class="share_select"
              placeholder="请选择短链分享模式"
              :class="{
                disSelet: isStatus == 2,
              }"
              :disabled="isStatus == 2"
              @change="incomeModeChange"
            >
              <el-option
                v-for="item in rebateList"
                :key="item.name"
                :label="item.name"
                :style="item.disabled == '1' ? 'cursor: pointer ' : ''"
                :value="item.name"
                :disabled="item.disabled == 1"
              >
                <div class="share_select_box" @click.prevent="toDaren(item)">
                  <div
                    class="income-name"
                    :class="item.disabled == '0' ? '' : 'income-name1'"
                  >
                    {{ item.name }}
                  </div>
                  <div class="income-right">
                    <div
                      class="income-intr"
                      v-if="item.info"
                      :class="
                        item.disabled == '1'
                          ? 'income-daren0'
                          : item.disabled == '0'
                          ? 'income-daren'
                          : ''
                      "
                    >
                      <img
                        v-if="item.disabled == '1'"
                        style="width: 14px; height: 14px; margin-right: 2px"
                        :src="$utils.getPng('web4/icon_mom')"
                      />
                      {{ item.info }}
                    </div>
                    <div class="income-checkbox">
                      <img
                        class="icon-scheck"
                        v-show="item.name == rebate_model"
                        :src="$utils.getPng('web4/icon-share-check')"
                      />
                    </div>
                  </div>
                </div>
              </el-option>
            </el-select>
          </div>

          <!-- 分享短链 创建成功 -->
          <div
            class="formBox"
            style="padding-bottom: 4px; margin-bottom: 0"
            v-if="isStatus == 4"
          >
            <div class="fontBox">
              <span class="font">标题</span>
              <span class="font" style="margin-left: 198px">短链</span>
            </div>
            <div class="batchBox">
              <div class="batch" v-for="(item, index) in batchUrl" :key="index">
                <span class="bfont1">{{ item.url_title }}</span>
                <span class="bfont1" style="margin-right: 0">{{
                  item.share_url
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-footer" v-if="isStatus != 2">
        <el-tooltip
          effect="dark"
          v-if="white_list != '' && isStatus != 4"
          placement="bottom-start"
          popper-class="short-popper"
        >
          <div slot="content">
            支持创建短链的域名：<br />
            <span>{{ white_list }}</span>
            <div>迅雷链thunder://、磁力链接magnet:</div>
          </div>
          <div class="left">
            <svg-btn class="icon2" icon-class="icon-share-2" />
            <span class="right">查看支持域名</span>
          </div>
        </el-tooltip>
        <div v-else></div>
        <div class="right">
          <fm-button
            v-if="isStatus == 1"
            :disabled="isType == 1 ? btnOne : btnTwo"
            @click="isType == 1 ? addLink() : addBatchLink()"
            type="primary"
            size="mdeium"
            round
            :loading="loading"
            style="font-size: 14px"
          >
            创建短链
          </fm-button>
          <!-- 编辑 按钮 -->
          <fm-button
            v-if="isStatus == 3"
            :disabled="btnOne"
            @click="addLink"
            round
            type="primary"
            size="mdeium"
            :loading="loading"
            style="font-size: 14px"
            >确 认</fm-button
          >
          <fm-button
            v-if="isStatus == 3"
            @click="cancel"
            round
            type="info"
            plain
            size="mdeium"
            style="font-size: 14px"
            >取 消</fm-button
          >
          <!-- 编辑 按钮 -->

          <!-- 批量创作成功 按钮 -->
          <fm-button
            v-if="isStatus == 4"
            @click="copyUrl(3)"
            round
            type="primary"
            size="mdeium"
            style="font-size: 14px"
            >复制标题和短链</fm-button
          >
          <fm-button
            v-if="isStatus == 4"
            @click="copyUrl(2)"
            round
            type="info"
            plain
            size="mdeium"
            style="font-size: 14px"
            >复制短链</fm-button
          >
          <!-- 批量创作成功 按钮 -->
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import {
  addShort,
  editShort,
  shortDetail,
  batchCreateAPI,
  shortModel,
  shortIconInfo,
  editShareModel,
} from '@/utils/apiList/short'
import { v4 as uuidv4 } from 'uuid';
export default {
  props: {
    //是否显示
    isShow: {
      type: Boolean,
      default: false,
    },
    //1是单个新建 2是批量新建
    isType: {
      type: [Number, String],
      default: 1,
    },
    // //1是新建 2是新建成功 3是编辑 4是批量创建成功
    // isStatus: {
    //   type: [Number, String],
    //   default: 1,
    // },
    // 2是查看 3是编辑
    status: {
      type: [Number, String],
      default: 0,
    },
    // 分享和编辑传来的详情
    detail: {
      type: Object,
      default: {},
    },
    //分享模式list
    rebateList: {
      type: Array,
      default: [],
    },
    //分享模式list 包含隐藏
    rebateAllList: {
      type: Array,
      default: [],
    },
    //支持域名
    white_list: {
      type: Array,
      default: '',
    },
    //最多添加的数量
    maxCount: {
      type: Number,
      default: 100,
    },
  },
  data() {
    return {
      isStatus: 1, //1是新建 2是新建成功 3是编辑 4是批量创建成功
      jump_url: '', //目标网址
      web_icon: this.$utils.getPng('icon-short-noDefault'), //图标
      rebate_model: '', //返利模式  1-免登录无条件跳转 2-登录后无条件跳转 3-去小程序看广告后跳转 4-去APP看广告后跳转
      url_title: '', //标题
      fshort: '', //生产的fshort
      share_url: '', //生成的链接
      batchUrl: [], //生成的url数据
      ed_arrList: '', //暂存数据
      ed_rebate_model: '', //编辑暂存返利模式
      loading: false,
      loading2: false,
      arrList: [
        {
          key: `card${uuidv4()}`,
          jump_url: '', //目标网址
          url_title: '', //标题
          icon: '', //图标base64格式
          url: '', //图标url格式
          empty: false, //是否为空 前端本地存
          domin: false, //是否不符合域名规则 前端本地存
          old_jump_url: '', //旧目标网址 用来对比的 前端本地存
        },
      ],
      editType:0,
    }
  },

  computed: {
    btnOne() {
      let state = true
      if (this.rebate_model) {
        state = false
      }
      return state
    },
    btnTwo() {
      let state = true
      if (this.rebate_model && this.url_title.trim() && this.jump_url.trim()) {
        state = false
      }
      return state
    },
    title() {
      //isType 1是单个新建 2是批量新建
      //isStatus 1是新建 2是新建成功 3是编辑 4是批量创建成功
      if (this.isType == 2) {
        if (this.isStatus == 4) {
          return '分享多个短链'
        }
        return '批量新建短链'
      }
      if (this.isStatus == 2) {
        return '分享短链'
      } else if (this.isStatus == 3) {
        return '编辑短链'
      } else {
        return '新建短链'
      }
    },
  },
  watch: {
    isShow: function (val) {
      if (val) {
        if (this.status == 2 || this.status == 3) {
          this.isStatus = this.status
          this.loading2 = true
          this.getShortDetail()
        } else {
          this.getShortModel()
        }
      }
    },
  },
  methods: {
    //获取模式
    getShortModel() {
      shortModel()
        .then(res => {
          if (res.status == 1) {
            this.$emit('upRebate', res.data.config, res.data.full_config)
            let arr = res.data.config.find(item => item.select == 1)
            this.rebate_model = arr?.name
          }
        })
        .catch(err => {})
    },
    //添加目标地址
    addArr() {
      // 清除所有错误状态
      this.arrList.forEach(item => {
        item.empty = false
      })
      if (this.arrList.length >= this.maxCount) {
        return
      }
      this.arrList.push({
        key: `card${uuidv4()}`,
        jump_url: '',
        url_title: '',
        icon: '',
        url: '',
        empty: false,
        domin: false,
        old_jump_url: '',
      })
      // 新增后滚动到容器底部
      this.$nextTick(() => {
        const arrRef = this.$refs.arrRef
        if (arrRef) {
          arrRef.scrollTo({
            top: arrRef.scrollHeight, // 滚动到最底部
            behavior: 'smooth', // 平滑滚动效果
          })
        }
      })
    },
    //移除目标地址
    removeArr(index) {
      const itemToRemove = this.arrList[index]
      this.arrList = this.arrList.filter(item => item.key != itemToRemove.key)
    },
    // 动态获取图标地址
    getIconSrc(item) {
      // 1. 如果链接为空，显示默认图标
      if (!item.jump_url) {
        return this.$utils.getPng('icon-shortLink-yesDefault')
      }

      // 2. 如果有后端返回的图标，显示该图标
      if (item.icon) {
        return item.icon
      }

      // 3. 链接不为空但没有后端图标，显示默认图标
      return this.$utils.getPng('icon-shortLink-noDefault')
    },
    // 失焦事件处理
    async handleInputBlur(item) {
      //值没改变 直接清空
      if (item.jump_url === item.old_jump_url) {
        return
      }
      // 如果链接为空，清空后端图标并直接返回
      if (!item.jump_url.trim()) {
        item.icon = ''
        return
      }
      item.old_jump_url = item.jump_url
      try {
        let res = await shortIconInfo({
          url: item.jump_url,
        })
        if (res.status == 1) {
          if (res.data.title != '') {
            // 先获取原始标题（确保是字符串，避免非字符串类型的异常）
            const originalTitle = String(res.data.title)
            // 截断超过50的部分，再赋值
            item.url_title =
              originalTitle.length > 50
                ? originalTitle.substring(0, 50)
                : originalTitle
          }
          if (res.data.path != '') {
            item.icon = res.data.path
          }else{
            item.icon = this.$utils.getPng('icon-shortLink-noDefault')
          }
            item.url = res.data.url
        }
      } catch (error) {}
    },
    // 合并处理输入事件，当两个字段都有值时清除错误状态
    handleInput(row,num) {
      if (row.jump_url.trim() && row.url_title.trim()) {
        row.empty = false
      }
      if(num == 1){
        row.icon = ''
        row.url = ''
      }
    },
    handleInputFocus(row){
      row.domin = false
    },
    //验证短链list是否都已经填写完成
    checkLinkType() {
      // 清除所有错误状态
      this.arrList.forEach(item => {
        item.empty = false
      })

      // 验证所有输入
      let hasError = false
      let firstErrorIndex = -1

      this.arrList.forEach((item, i) => {
        if (!item.jump_url.trim() || !item.url_title.trim()) {
          item.empty = true
          hasError = true
          if (firstErrorIndex === -1) {
            firstErrorIndex = i
          }
        }
      })

      // 如果有错误，滚动到第一个错误卡片
      if (hasError && firstErrorIndex !== -1) {
        this.$nextTick(() => {
          const errorCard = this.$refs[`card${firstErrorIndex}`][0]
          if (errorCard) {
            errorCard.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        })
        this.$toast('短链信息未填写完整，请完善', 2)
        return false
      }
      return true
    },
    // 验证短链是否有不符合域名的目标网址（根据后端返回的错误下标处理）
    checkLinkStatus(errorObjects) {
      // 清除所有错误状态
      this.arrList.forEach(item => {
        item.domin = false;
      });

      // 标记后端返回的错误下标
      const errorIndices = errorObjects?.map(obj => obj.i) || [];
      const hasError = errorIndices.length > 0;
      if (hasError) {
        errorIndices.forEach(index => {
          // 确保下标在有效范围内
          if (this.arrList[index] !== undefined) {
            this.arrList[index].domin = true;
          }
        });

        // 滚动到第一个错误卡片
        const firstErrorIndex = errorIndices[0];
        this.$nextTick(() => {
          const errorCard = this.$refs[`card${firstErrorIndex}`]?.[0];
          if (errorCard) {
            errorCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });
        return false;
      }

      return true;
    },
    getRebateId(rebateName) {
      //找到 name 匹配的元素
      const item = this.rebateAllList.find(item => item.name == rebateName)
      // 如果找到则返回 id
      return item ? item.id : ''
    },
    getRebateName(rebateId) {
      //找到 id 匹配的元素
      const item = this.rebateAllList.find(item => item.id == rebateId)
      // 如果找到则返回 id
      return item ? item.name : ''
    },
    //新建短链
    addLink: _.debounce(
      function () {
        //判断是否有未填信息
        if (this.btnOne || this.loading) {
          return
        }
        if (!this.checkLinkType()) {
          return
        }
        if (
          this.isStatus == 3 &&
          this.rebate_model == this.ed_rebate_model &&
          JSON.stringify(this.arrList) == JSON.stringify(this.ed_arrList)
        ) {
          this.isStatus = 2
          return
        }
        //新建的时候后端不接收base64的格式，需要把icon变成url(但实际渲染是用base64)
        const list = this.arrList.map(item => {
          const newItem = { ...item }
          //后端不需要这四个字段，删掉
          delete newItem.key
          delete newItem.empty
          delete newItem.domin
          delete newItem.old_jump_url

          // 新建状态下替换 icon 并删除 url
          if (newItem.url) {
            newItem.icon = newItem.url
            delete newItem.url
          }
          return newItem
        })
        let rebate_model = this.getRebateId(this.rebate_model)
        let data = {
          fshort: this.fshort,
          rebate_model,
          list,
        }
        this.loading = true
        addShort(data)
          .then(res => {
            if (res.status == 1) {
              this.fshort = res.data.fshort
              if (this.arrList.length > 1) {
                this.web_icon = this.$utils.getPng('icon-shortLink-noDefault')
              } else {
                this.web_icon = this.arrList?.[0].icon
              }
              this.url_title = res.data.url_title
              this.jump_url = res.data.jump_url
              this.share_url = res.data.share_url
              this.isStatus = 2
              this.$toast(res.msg, 1)
              this.loading = false
              this.arrList = [
                {
                  key: `card${uuidv4()}`,
                  jump_url: '', //目标网址
                  url_title: '', //标题
                  icon: '', //图标base64格式
                  url: '', //图标url格式
                  empty: false, //是否为空
                  domin: false, //是否不符合域名规则
                  old_jump_url: '', //旧目标网址 用来对比的
                },
              ]
              setTimeout(() => {
                this.$emit('refresh')
              }, 300)
            } else if (res.status == 2) {
              this.loading = false
              this.$toast(res.msg, 2)
            }else if (res.status == 3){
              //不符合域名规则
              this.checkLinkStatus(res.data.error_list)
              this.loading = false
              this.$toast(res.msg, 2)
            } else {
              this.loading = false
              this.$toast(res.msg, 3)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //批量新建短链
    addBatchLink: _.debounce(
      function () {
        if (this.btnTwo || this.loading) {
          return
        }
        let rebate_model = this.getRebateId(this.rebate_model)
        let data = {
          content: this.jump_url,
          rebate_model,
          url_title: this.url_title,
          is_single: this.isType,
        }
        this.loading = true
        batchCreateAPI(data)
          .then(res => {
            if (res.status == 1) {
              this.fshort = res.data.fshort
              this.web_icon = res.data.web_icon
              this.batchUrl = res.data.list
              this.isStatus = 4
              this.$toast(res.msg, 1)
              this.loading = false
              setTimeout(() => {
                this.$emit('refresh')
              }, 300)
            } else if (res.status == 2) {
              this.loading = false
              this.$toast(res.msg, 2)
            } else {
              this.loading = false
              this.$toast(res.msg, 3)
            }
          })
          .catch(err => {
            this.loading = false
          })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //获取详情信息
    getShortDetail(){
      this.editType = 1
      this.fshort = this.detail.fshort
      this.rebate_model = this.getRebateName(this.detail.rebate_model)
      this.jump_url = this.detail.jump_url
      this.share_url = this.detail.share_url
      this.url_title = this.detail.url_title
      this.arrList = this.detail.s_list.map(item => ({
        ...item,
        key: `card${uuidv4()}`,
        old_jump_url: '',
        empty: false,
        domin: false,
      }))
      if (this.arrList.length > 1) {
        this.web_icon = this.$utils.getPng('icon-shortLink-noDefault')
      } else {
        this.web_icon = this.arrList?.[0].icon
      }
      if (this.isStatus == 3) {
        this.ed_rebate_model = this.rebate_model
        this.ed_arrList = JSON.parse(JSON.stringify(this.arrList))
      }
      setTimeout(() =>{
        this.editType = 0
      },500)
      this.loading2 = false
    },
    //点击编辑
    editLink() {
      this.loading2 = true
      this.getEditDetail(this.fshort)
      // this.$emit('openShort',this.fshort,3)
      this.isStatus = 3
    },
    //获取详情信息
    getEditDetail(fshort) {
      this.editType = 1
      shortDetail({
        fshort: fshort,
      })
        .then(res => {
          if (res.status == 1) {
            this.fshort = res.data.detail.fshort
            this.rebate_model = this.getRebateName(res.data.detail.rebate_model)
            this.jump_url = res.data.detail.jump_url
            this.share_url = res.data.detail.share_url
            this.url_title = res.data.detail.url_title
            this.arrList = res.data.detail.s_list.map(item => ({
              ...item,
              key: `card${uuidv4()}`,
              old_jump_url: '',
              empty: false,
              domin: false,
            }))
            if (this.arrList.length > 1) {
              this.web_icon = this.$utils.getPng('icon-shortLink-noDefault')
            } else {
              this.web_icon = this.arrList?.[0].icon
            }
            if (this.isStatus == 3) {
              this.ed_rebate_model = this.rebate_model
              this.ed_arrList = JSON.parse(JSON.stringify(this.arrList))
            }
            setTimeout(() =>{
              this.editType = 0
            },500)
          }else {
            this.$toast(res.msg,2)
          }
          this.loading2 = false
        })
        .catch(err => {
          this.loading2 = false
          this.editType = 0
        })
    },
    //编辑短链确认事件
    confirm: _.debounce(
      function () {
        if (!this.checkLinkType()) {
          return
        }
        if (this.btnOne || this.loading) {
          return
        }
        if (this.rebate_model == this.ed_rebate_model) {
          this.isStatus = 2
          return
        }
        let rebate_model = this.getRebateId(this.rebate_model)
        let data = {
          jump_url: this.jump_url,
          rebate_model,
          url_title: this.url_title,
          fshort: this.fshort,
        }
        this.loading = true
        editShort(data).then(res => {
          if (res.status == 1) {
            this.url_title = res.data.url_title
            this.isStatus = 2
            setTimeout(() => {
              this.$emit('refresh')
            }, 300)
            this.loading = false
            this.$toast(res.msg, 1)
          } else if (res.status == 2) {
            this.loading = false
            this.$toast(res.msg, 2)
          } else {
            this.loading = false
            this.$toast(res.msg, 3)
          }
        })
      },
      500,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //编辑短链取消事件
    cancel() {
      if (this.status == 3) {
        this.handleClose()
      } else {
        this.rebate_model = this.ed_rebate_model
        this.arrList = this.ed_arrList
        this.isStatus = 2
      }
    },
    //关闭弹窗，清除状态
    handleClose() {
      this.$emit('handleClose')
      setTimeout(() => {
        this.arrList = [
          {
            key: `card${uuidv4()}`,
            jump_url: '', //目标网址
            url_title: '', //标题
            icon: '', //图标base64格式
            url: '', //图标url格式
            empty: false, //是否为空
            domin: false, //是否不符合域名规则
            old_jump_url: '', //旧目标网址 用来对比的
          },
        ]
        this.jump_url = ''
        this.rebate_model = ''
        this.url_title = ''
        this.fshort = ''
        this.share_url = ''
        this.batchUrl = []
        this.ed_rebate_model = ''
        this.ed_arrList = []
        this.isStatus = 1
      }, 200)
    },
    //复制短链
    copyUrl(num) {
      let url
      if (num == 1) {
        url = this.share_url
      } else if (num == 2) {
        let arr = []
        this.batchUrl.forEach(item => {
          arr.push(item.share_url)
        })
        url = arr.join('\n')
      } else if (num == 3) {
        // 处理数组，生成拼接后的字符串
        url = this.batchUrl
          .map(item => {
            return `${item.url_title} ${item.share_url}`
          })
          .join('\n')
      }
      this.$copyText(url).then(
        e => {
          let msg = num == 3 ? '复制标题和短链成功' : '复制短链成功'
          this.$toast(msg, 1)
        },
        function (e) {}
      )
    },
    //点击模式下拉框事件
    incomeModeChange() {
      if (this.isStatus == 2) {
        let rebate_model = this.getRebateId(this.rebate_model)
        let data = {
          rebate_model,
          fshort: this.fshort,
        }
        editShareModel(data).then(res => {
          if (res.status == 1) {
            this.$emit('refresh')
            this.$toast(res.msg, 1)
          } else {
            this.$toast(res.msg, 2)
          }
        })
      }
    },
    onError(event) {
      // 防止默认图也加载失败导致无限循环（可选，但建议加）
      if (event.target.src != this.$utils.getPng('icon-shortLink-noDefault')) {
        event.target.src = this.$utils.getPng('icon-shortLink-noDefault')
      }
    },
    //点击跳转达人中心
    toDaren(item) {
      if (item.disabled == 1) {
        window.open(`${this.$glb.goLLZ}`, '_blank')
        return
      }
    },
    //点击跳转达人中心-帮助中心-短链
    toCm() {
      window.open(`${this.$glb.goLLZ}/help?tag=11`, '_blank')
    },
  },
}
</script>

<style lang="scss">
.ShortDialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .dialog-body {
    padding-bottom: 24px;
  }
  .d-header {
    margin: 20px 0 0 24px;
  }
  .d-content {
    .share_select {
      .is-disabled:hover {
        @include useTheme {
          background: getVar('bg-color-fill2');
        }
      }
    }
    .share_select_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      position: relative;
    }
    .warn-box {
      height: 32px;
      @include useTheme {
        background: getVar('text-color1-f9f9f9');
      }
      display: flex;
      align-items: center;
      margin-top: 16px;
      .svg-icon {
        width: 16px;
        height: 16px;
        margin-left: 24px;
        margin-right: 8px;
      }
      span {
        font-size: 12px;
        line-height: 20px;
        @include useTheme {
          color: getVar('text-color1-8a8b92');
        }
      }
    }
    .file-info {
      display: flex;
      align-items: center;
      margin-bottom: 24px;
      padding: 16px 24px 0 24px;
      .file_icon {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 16px;
        @include useTheme {
          border: 0.5px solid getVar('color-e5e5e5-535353');
        }
        .icon {
          width: 20px;
          height: 20px;
          object-fit: cover;
          border-radius: 6px;
        }
      }
      .info {
        display: flex;
        flex-direction: column;
        height: 42px;
        .nameBox {
          display: flex;
          align-items: center;
          .name {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            max-width: 368px;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            @include useTheme {
              color: getVar('text-color2-2c2c2c');
            }
          }
          .edit {
            width: 14px;
            height: 14px;
            margin-left: 4px;
            cursor: pointer;
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
        }
        .link {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          max-width: 368px;
          display: inline-block;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          @include useTheme {
            color: getVar('text-color1-8a8b92');
          }
        }
      }
    }
    .shortLink {
      // padding: 16px 24px 0 24px;
      padding: 0;
      .formBox {
        padding: 0 24px;
        margin-bottom: 24px;
        .fontBox {
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          .left {
            display: flex;
            align-items: center;
          }
          .right {
            font-weight: 400;
            font-size: 12px;
            line-height: 20px;
            cursor: pointer;
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
          .font {
            font-weight: 500;
            font-size: 14px;
            line-height: 22px;
            @include useTheme {
              color: getVar('text-color1-2c2c2c');
            }
          }
          .red {
            @include useTheme {
              color: getVar('text-color1-F53F3F') !important;
            }
          }
          .icon {
            width: 16px;
            height: 16px;
            margin-left: 4px;
          }
          .icon2 {
            width: 16px;
            height: 16px;
            margin-right: 4px;
            margin-bottom: 1px;
          }
        }
        .disSelet {
          .el-input__inner {
            @include useTheme {
              color: getVar('text-color1-8a8b92');
            }
          }
        }
        .urlBox {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .el-input {
            width: 264px;
          }
          .el-input__inner {
            width: 264px;
            height: 40px;
            @include useTheme {
              background: getVar('text-color1-f9f9f9');
              border: 1px solid getVar('color-e5e5e5-3b3b3b');
              color: getVar('text-color1-8a8b92');
            }
            border-radius: 8px;
            font-size: 12px;
            padding-left: 12px;
            line-height: 40px;
          }
          .copy-btn {
            width: 152px;
            height: 40px;
          }
        }
        .el-select {
          width: 100%;
        }
        .title {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 60px !important;
          }
        }
        .titleAll {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 188px !important;
          }
        }
        .allTitle {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 188px !important;
          }
        }
        .allTitle2 {
          .el-textarea__inner {
            padding: 10px 12px;
            height: 188px !important;
            @include useTheme {
              background: getVar('text-color1-f9f9f9');
              border: 1px solid getVar('color-e5e5e5-3b3b3b');
              color: getVar('text-color1-2c2c2c');
            }
          }
        }
        .addressInput {
          .el-input__inner {
            @include useTheme {
              background: getVar('bg-color-f6f6f6');
              border: 1px solid getVar('bg-color-f6f6f6');
              color: getVar('text-color1-d9d9d9');
            }
          }
        }
        .batchBox {
          width: 100%;
          height: 188px;
          background: #f6f6f6;
          border-radius: 8px;
          overflow-y: auto;
          padding: 10px 12px;
          display: flex;
          align-items: flex-start;
          flex-direction: column;
          .batch {
            display: flex;
            align-items: center;
            .bfont1 {
              font-weight: 400;
              font-size: 12px;
              line-height: 20px;
              width: 194px;
              margin-right: 20px;
              @include multiline(1);
              @include useTheme {
                color: getVar('text-color1-2c2c2c');
              }
            }
          }
        }
      }
      .arrBox {
        padding: 16px 24px 0 24px;
        max-height: 416px;
        overflow: auto;
        .arr {
          padding: 12px;
          border-radius: 16px;
          margin-bottom: 16px;
          height: 192px;
          @include useTheme {
            border: getVar('border-color-e5e5e5');
          }
          &:hover {
            // border: 1px solid #F67942 !important;
            .right {
              display: flex !important;
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
          .box {
            margin-bottom: 16px;
            .fontBox {
              display: flex;
              align-items: center;
              height: 18px;
              margin-bottom: 8px;
              .left {
                display: flex;
                align-items: center;
              }
              .right {
                align-items: center;
                cursor: pointer;
                display: none;
              }
              .font {
                font-weight: 400;
                font-size: 13px;
                line-height: 18px;
                @include useTheme {
                  color: getVar('text-color1-52565a');
                }
              }
              .font2 {
                font-weight: 400;
                font-size: 12px;
                line-height: 20px;
                @include useTheme {
                  color: getVar('text-color1-F53F3F') !important;
                }
              }
              .red {
                height: 18px;
                @include useTheme {
                  color: getVar('text-color1-F53F3F') !important;
                }
              }
              .icon {
                width: 16px;
                height: 16px;
                margin-left: 4px;
              }
              .icon2 {
                width: 16px;
                height: 16px;
                margin-right: 4px;
                margin-bottom: 1px;
              }
              .icon3 {
                width: 16px;
                height: 16px;
                margin-right: 4px;
              }
            }
            .inputBox {
              position: relative;
              .img {
                position: absolute;
                top: 50%;
                transform: translateY(-50%);
                width: 16px;
                height: 16px;
                z-index: 1;
                left: 12px;
                object-fit: cover;
                border-radius: 5px;
              }
              .linkInput {
                .el-input__inner {
                  padding-left: 34px;
                }
              }
            }
            .title {
              .el-textarea__inner {
                padding: 10px 12px;
                height: 60px !important;
              }
            }
          }
        }
        .arrError {
          @include useTheme {
            border: 1px solid getVar('text-color1-F53F3F') !important;
          }
        }
      }
      .btnBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;
        .addBtn {
          width: 136px;
          height: 32px;
          border-radius: 8px;
          color: #f67942;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          @include useTheme {
            border: getVar('border-color-e5e5e5');
          }
          .icon {
            width: 14px;
            height: 14px;
          }
          .addFont {
            font-weight: 400;
            font-size: 14px;
            line-height: 22px;
            margin-left: 4px;
          }
        }
      }
    }
  }
  .d-footer {
    margin: 20px 24px 0 24px;
    justify-content: space-between !important;
    .left {
      display: flex;
      align-items: center;
      .right {
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        cursor: pointer;
        @include useTheme {
          color: getVar('text-color1-8a8b92');
        }
      }
      .icon2 {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        margin-bottom: 1px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  /* 新建时的进入动画（对应el-zoom-in-top） */
  .link-item-enter-active {
    animation: linkZoomInTop 0.6s ease-out forwards;
  }

  /* 删除时的离开动画（对应el-zoom-in-bottom） */
  .link-item-leave-active {
    animation: linkZoomOutBottom 0.2s ease-in forwards;
  }

  /* 进入动画：从上方缩放进入 */
  @keyframes linkZoomInTop {
    0% {
      opacity: 0;
      transform: scaleY(0.8) translateY(-20px); /* 初始位置：上方20px，略缩小 */
    }
    100% {
      opacity: 1;
      transform: scaleY(1) translateY(0); /* 结束位置：正常位置 */
    }
  }

  /* 离开动画：从当前位置缩放到下方消失 */
  @keyframes linkZoomOutBottom {
    0% {
      opacity: 1;
      transform: scaleY(1) translateY(0); /* 初始位置：正常位置 */
    }
    100% {
      opacity: 0;
      transform: scaleY(0.8) translateY(20px); /* 结束位置：下方20px，略缩小 */
    }
  }
}
</style>
<style lang="scss" scoped>
::v-deep .el-input {
  .el-input__inner {
    font-size: 12px !important;
    &::placeholder {
      font-size: 12px !important;
    }
  }
}
::v-deep.el-textarea {
  .el-textarea__inner {
    font-size: 12px !important;
    &::placeholder {
      font-size: 12px !important;
    }
  }
}
</style>
